import { Box } from '@mui/material'
import { iWebFormField } from './schema';
import { WebFormTextArea } from './FieldTypes/TextArea';
import { WebFormInputBox } from './FieldTypes/InputBox';
import { WebFormDropDown } from './FieldTypes/DropDown';
import { WebCheckBox } from './FieldTypes/CheckBox';
import HeaderContent from './FieldTypes/HeaderContent';

const SelectWebformField = ({block, value = null, editable = true,idNamespace }:{block : iWebFormField,value?:any,editable?:boolean,idNamespace?:string}) => {
    const { fieldType} = block;
    return (
        <Box>
            {(fieldType === "Heading") && <HeaderContent idNamespace={idNamespace} fieldConfig={block} />}
            {fieldType === "TextArea" && <WebFormTextArea idNamespace={idNamespace} fieldConfig={block} value={value} editable={editable}/>}
            {(fieldType === "InputBox" || fieldType === "DatePicker") && <WebFormInputBox idNamespace={idNamespace} fieldConfig={block} value={value}  editable={editable} enableDateAutoPopup={true}/>}
            {fieldType === "DropDown" && <WebFormDropDown idNamespace={idNamespace} fieldConfig={block} value={value} editable={editable}/>}
            {fieldType === "CheckBox" && <WebCheckBox idNamespace={idNamespace} fieldConfig={block}  value={value} editable={editable}/>}
        </Box>
    )
}

export default SelectWebformField
